import { render, staticRenderFns } from "./AutoLoan.vue?vue&type=template&id=640d712c&"
import script from "./AutoLoan.vue?vue&type=script&lang=js&"
export * from "./AutoLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports